module.exports = __webpack_public_path__ + "img/message-out-svg.c1d99cef.svg";